import { flagsIconMapper } from '@com/config/ai-support-language'

export function formatLabel(code: string, name: string): string {
  return `${flagsIconMapper[code as keyof typeof flagsIconMapper]} ${
    name || code
  }`
}
